import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import theme from '../config/theme'
import de from 'vuetify/es5/locale/de'

Vue.use(Vuetify)

export default new Vuetify({
    ...theme,
    lang: { locales: { de }, current: 'de'}
});
